export enum GtmProductType {
    Normal = 'normal',
    LabTest = 'lab_test',
    Marketplace = 'marketplace',
}
